import { useEffect, useState } from "react";
import { api, BACKEND } from "./api";
import { vid, source } from "@/pages/landing/parts";

export const VARIANT_KEY = "sb_ab_variant";
export const device = () => (window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop");

export const abTrack = (event, { lang = "en", variant = "", key = "", props = {} } = {}) =>
  api.post("/public/ab", { event, visitor_id: vid(), source: source(), device: device(), lang, variant, key,
    props: event === "landing_page_view" && sessionStorage.getItem("sb_ab_entry") === "start" ? { ...props, entry: "start" } : props })
    .then((r) => { if (r.data?.variant && !localStorage.getItem(VARIANT_KEY)) localStorage.setItem(VARIANT_KEY, r.data.variant); })
    .catch(() => {});

export function useSeen(id, onSeen, enabled = true) {
  useEffect(() => {
    const el = enabled && document.getElementById(id);
    if (!el) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting || e.boundingClientRect.top < 0) { io.disconnect(); onSeen(); } }, { threshold: [0, 0.4] });
    io.observe(el);
    return () => io.disconnect();
  }, [id, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
}

const CAT_FR = {
  "B2B Services": "Services aux entreprises", "Convenience & Errands": "Services pratiques et courses", "Digital & AI": "Digital et IA", "Education & Skills": "Éducation et compétences",
  "Events & Simple Resale": "Événements et revente simple", "Food & Beverage": "Alimentation et boissons", "Green & Local Production": "Production locale et verte",
  "Home & Neighbourhood": "Maison et quartier", "Home & Property": "Maison et propriété", "Lifestyle, Pet & Senior": "Bien-être, animaux et seniors",
  "Retail & Resale": "Commerce et revente", "Simple Digital & Admin": "Digital simple et administratif", "Tourism & Experiences": "Tourisme et expériences",
};
export const catLabel = (c, lang) => (lang === "fr" && CAT_FR[c]) || c;

export function useLandingImages() {
  const [imgs, setImgs] = useState(null);
  useEffect(() => {
    api.get("/public/landing-images").then((r) => setImgs(Object.fromEntries(Object.entries(r.data).filter(([, v]) => v).map(([k, v]) => [k, `${BACKEND}${v}`])))).catch(() => setImgs({}));
  }, []);
  return imgs;
}
